import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { BookingService } from '../../../services/booking.service';

@Component({
    template:`
    <div *ngIf="!isCart()">
      <div style="font-weight: 450 !important; position: relative; top: 5px;">{{getValueFirst()}}</div>
      <div *ngFor='let text of LowerText' style="font-size:11px !important; font-weight: 100 !important; position: relative; top: 5px; margin-top: 8px">{{getValueExpandable()}}</div>
    </div>
  
    <div *ngIf="isCart()">
      <div style="font-weight: 450 !important; position: relative; top: 5px;">{{getValueFirst()}}</div>
      <div (click)=toggle() *ngIf="!showExpandable" style="font-size:11px !important; color:#7777EE; margin-top:6px; cursor: pointer;">Show Booking Numbers</div>
      <div *ngIf="showExpandable" style="margin-top: 16px;">
        <div *ngFor='let text of getValueExpandable()' style="font-size:11px !important; font-weight: 100 !important; position: relative; top: 5px; margin-top: 8px; display: flex;">
          {{text}}
          <div (click)=openBooking(text) *ngIf="text.length>0" style="font-size:18px !important; color:#7777EE; cursor: pointer; margin-left: 4px;">👁</div>
        </div>
      </div>
      <div (click)=toggle() *ngIf="showExpandable" style="font-size:11px !important; color:#7777EE; margin-top:6px; cursor: pointer;">Hide Booking Numbers</div>
    </div>
      `
})
export class DynamicRendererComponent implements ViewCell, OnInit {

  constructor(
    private bookSrvc: BookingService,
  ) { }

  @Input() value: string;
  @Input() rowData: any;

  ngOnInit(): void {
  }


  getValueFirst() {
    var newString = this.value.split('||');
    return newString[0];
  }
  getValueExpandable() {
    var newString = this.value.split('||');
    return newString.slice(1);
  }

  showExpandable = false;
  toggle() {
    this.showExpandable = !this.showExpandable;
  }

  openBooking(bookingNumber:string) {
    // console.log("open booking", bookingNumber);
    this.bookSrvc.openBooking$.next(bookingNumber);
  }

  isCart():boolean {
    return this.value.toLowerCase().includes('hhcrt');
  }
}
